






































































































import Vue from 'vue';
import moment from 'moment';
import { mapState, mapGetters } from 'vuex';
import { setGtmClass } from '../lib/utilities/gtmClass';
import { LowCreditThreshold } from '../lib/constants';

export default Vue.extend({
  name: 'AccountStatusBar',
  data() {
    return {
      currentDate: new Date(),
      timer: null as any
    };
  },
  mounted: function () {
    this.$nextTick(function () {
      // Code that will run only after the
      // entire view has been rendered
      setGtmClass('gtm-upgrade-ribbon');
    });
  },

  created() {
    this.timer = setInterval(() => {
      this.currentDate = new Date();
    }, moment.duration(1, 'minute').asMilliseconds());
  },

  beforeDestroy() {
    clearInterval(this.timer);
  },

  computed: {
    ...mapState('user', ['creditsAvailable', 'balances']),
    ...mapGetters('client', [
      'isTelkomClient',
      'isShopifyClient',
      'isTrialClient',
      'isActivePaidClient',
      'hasTrialExpired',
      'hasLessThanCredits',
      'hasMessageSendingPhoneNumber'
    ]),
    ...mapGetters('subscription', ['timeLeftForTrialDescription']),
    ...mapGetters('shopify', ['isNotConnectedToShopify']),

    showBanner() {
      return (
        this.showShopifyBar ||
        this.hasTrialExpired ||
        (this.isTrialClient && this.hasLessThanCredits(LowCreditThreshold)) ||
        this.showLowCreditsBar ||
        this.isTrialClient ||
        this.showBuyCreditsBar
      );
    },

    // The 'show' predicates should return false by default while data is being loaded.
    // This ensures status bar remains hidden until it is flipped to true by any of
    // the below conditions.
    showShopifyBar() {
      return this.isShopifyClient && this.isNotConnectedToShopify;
    },

    showLowCreditsBar(): boolean {
      return (
        this.hasLessThanCredits(LowCreditThreshold) &&
        this.hasMessageSendingPhoneNumber
      );
    },

    showTrialBar(): boolean {
      return this.isTrialClient;
    },

    showExpiredBar(): boolean {
      return this.hasTrialExpired;
    },

    showLowCreditsAndTrialBar(): boolean {
      return this.isTrialClient && this.hasLessThanCredits(LowCreditThreshold);
    },

    showBuyCreditsBar(): boolean {
      return this.hasMessageSendingPhoneNumber && this.balances?.length === 0;
    },

    timeLeftForTrial(): string {
      if (!this.isTrialClient) return '';

      return this.timeLeftForTrialDescription;
    }
  },

  watch: {
    showBanner: {
      handler: function (value) {
        this.$emit('show-warning', !!value);
      },
      immediate: true
    }
  },

  methods: {
    upgradeAccount() {
      if (this.isTelkomClient) this.openChat();
      else this.$router.push({ name: 'plans' });
    },

    openChat() {
      this.$intercom.openChat(
        "Hi Mobiz Team, I'd like to request more credits."
      );
    },

    topUpAccount() {
      this.$router.push({ name: 'pay-as-you-go' });
    }
  }
});
